import { Trailer } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getAll(): Promise<readonly Trailer[]> {
  return DesignService.get('trailers');
}

export function insert(name: string): Promise<Trailer> {
  return DesignService.post('trailers', { data: { name } });
}

export function setArchiveStatus(trailerGuid: string, archived: boolean): Promise<void> {
  return DesignService.post(`trailers/${trailerGuid}/setArchiveStatus/${archived}`);
}
